import {
    //@ test stack overview value
    SET_STK_MINTEMP_PSM1,
    // [TESTLIST] display alarm label 250812
    // [UPDATE] BUGFIX display alarm label 250813
    SET_IS_ALARM_SET_MAIN,
    SET_IS_ALARM_SET_PSM1,
    SET_IS_ALARM_SET_PSM2,
    SET_IS_ALARM_SET_PSM3,
    SET_IS_ALARM_SET_PSM4,
    SET_IS_ALARM_SET_PSM5,
    SET_PREV_ALARM_MAIN,
    SET_PREV_ALARM_PSM1,
    SET_PREV_ALARM_PSM2,
    SET_PREV_ALARM_PSM3,
    SET_PREV_ALARM_PSM4,
    SET_PREV_ALARM_PSM5,
    SET_CURR_ALARM_MAIN,
    SET_CURR_ALARM_PSM1,
    SET_CURR_ALARM_PSM2,
    SET_CURR_ALARM_PSM3,
    SET_CURR_ALARM_PSM4,
    SET_CURR_ALARM_PSM5,
    SET_TE900C_ENABLE_PSM1,
    SET_TE900C_ENABLE_PSM2,
    SET_TE900C_ENABLE_PSM3,
    SET_TE900C_ENABLE_PSM4,
    SET_TE900C_ENABLE_PSM5
} from '../constants/actions';

const initialState = {
    // [UPDATE] BUGFIX display alarm label 250813
    isAlarmSetMAIN : false,
    isAlarmSetPSM1 : false,
    isAlarmSetPSM2 : false,
    isAlarmSetPSM3 : false,
    isAlarmSetPSM4 : false,
    isAlarmSetPSM5 : false,

    prevAlarmMAIN : 0,
    prevAlarmPSM1 : 0,
    prevAlarmPSM2 : 0,
    prevAlarmPSM3 : 0,
    prevAlarmPSM4 : 0,
    prevAlarmPSM5 : 0,

    currAlarmMAIN : 0,
    currAlarmPSM1 : 0,
    currAlarmPSM2 : 0,
    currAlarmPSM3 : 0,
    currAlarmPSM4 : 0,
    currAlarmPSM5 : 0,

    // [UPDATE] TE900C Enable
    TE900CEnablePSM1 : true,
    TE900CEnablePSM2 : true,
    TE900CEnablePSM3 : true,
    TE900CEnablePSM4 : true,
    TE900CEnablePSM5 : true,

};

// TODO : case문으로 변경하기...
const dataReducer = (state = initialState, action) => {
    if (action.type === SET_IS_ALARM_SET_MAIN) {
        return {...state, isAlarmSetMAIN: action.isAlarmSetMAIN};
    } else if (action.type === SET_IS_ALARM_SET_PSM1) {
        return { ...state, isAlarmSetPSM1: action.isAlarmSetPSM1 };
    } else if (action.type === SET_IS_ALARM_SET_PSM2) {
        return { ...state, isAlarmSetPSM2: action.isAlarmSetPSM2 };
    } else if (action.type === SET_IS_ALARM_SET_PSM3) {
        return { ...state, isAlarmSetPSM3: action.isAlarmSetPSM3 };
    } else if (action.type === SET_IS_ALARM_SET_PSM4) {
        return { ...state, isAlarmSetPSM4: action.isAlarmSetPSM4 };
    } else if (action.type === SET_IS_ALARM_SET_PSM5) {
        return { ...state, isAlarmSetPSM5: action.isAlarmSetPSM5 };
    } else if (action.type === SET_PREV_ALARM_MAIN) {
        return { ...state, prevAlarmMAIN: action.prevAlarmMAIN };
    } else if (action.type === SET_PREV_ALARM_PSM1) {
        return { ...state, prevAlarmPSM1: action.prevAlarmPSM1 };
    } else if (action.type === SET_PREV_ALARM_PSM2) {
        return { ...state, prevAlarmPSM2: action.prevAlarmPSM2 };
    } else if (action.type === SET_PREV_ALARM_PSM3) {
        return { ...state, prevAlarmPSM3: action.prevAlarmPSM3 };
    } else if (action.type === SET_PREV_ALARM_PSM4) {
        return { ...state, prevAlarmPSM4: action.prevAlarmPSM4 };
    } else if (action.type === SET_PREV_ALARM_PSM5) {
        return { ...state, prevAlarmPSM5: action.prevAlarmPSM5 };
    }else if (action.type === SET_CURR_ALARM_MAIN) {
        return { ...state, currAlarmMAIN: action.currAlarmMAIN };
    } else if (action.type === SET_CURR_ALARM_PSM1) {
        return { ...state, currAlarmPSM1: action.currAlarmPSM1 };
    } else if (action.type === SET_CURR_ALARM_PSM2) {
        return { ...state, currAlarmPSM2: action.currAlarmPSM2 };
    } else if (action.type === SET_CURR_ALARM_PSM3) {
        return { ...state, currAlarmPSM3: action.currAlarmPSM3 };
    } else if (action.type === SET_CURR_ALARM_PSM4) {
        return { ...state, currAlarmPSM4: action.currAlarmPSM4 };
    } else if (action.type === SET_CURR_ALARM_PSM5) {
        return { ...state, currAlarmPSM5: action.currAlarmPSM5 };
    }  // [UPDATE] TE900C ENABLE 260105
     else if (action.type === SET_TE900C_ENABLE_PSM1){
        return { ...state, TE900CEnablePSM1 : action.TE900CEnablePSM1};
    } else if (action.type === SET_TE900C_ENABLE_PSM2){
        return { ...state, TE900CEnablePSM2 : action.TE900CEnablePSM2};
    } else if (action.type === SET_TE900C_ENABLE_PSM3){
        return { ...state, TE900CEnablePSM3 : action.TE900CEnablePSM3};
    } else if (action.type === SET_TE900C_ENABLE_PSM4){
        return { ...state, TE900CEnablePSM4 : action.TE900CEnablePSM4};
    } else if (action.type === SET_TE900C_ENABLE_PSM5){
        return { ...state, TE900CEnablePSM5 : action.TE900CEnablePSM5};
    } else {
        return state; // reducer의 default는 state 반환 
    }
};

export default dataReducer;